import { inject, Injectable } from '@angular/core';
import { PushNotificationSchema } from '@capacitor/push-notifications';
import { map, share, tap } from 'rxjs';
import { FirebaseCloudMessagingService } from '../infra/firebase-cloud-messaging.service';
import { NotificationAffectation } from './notification-affectation.model';
import { NotificationAlerte } from './notification-alerte.model';
import { NotificationBasique } from './notification-basique.model';
import { NotificationMission } from './notification-mission.model';
import { INotification } from './notification.model';
import { LoggingService } from '../../shared/logging.service';

@Injectable({
  providedIn: 'root',
})
export class NotificationInteractionService {
  readonly #fcm = inject(FirebaseCloudMessagingService);
  readonly #log = inject(LoggingService);

  readonly notificationTapped$ = this.#fcm.notificationTapped$.pipe(
    map(notification => this.typeNotification(notification)),
    tap(notif => this.#log.debug('Tapped notification: ', typeof notif, notif)),
    share()
  );
  readonly notificationReceived$ = this.#fcm.notificationReceived$.pipe(
    map(notification => this.typeNotification(notification)),
    tap(notif => this.#log.debug('Received notification: ', typeof notif, notif)),
    share()
  );

  private typeNotification(notification: PushNotificationSchema): INotification {
    const extra = this.getExtra(notification);
    let notif: INotification;

    if (extra.idAlerte) {
      notif = new NotificationAlerte(extra.idAlerte, notification.title, notification.body);
    } else if (extra.idAffectation) {
      notif = new NotificationAffectation(extra.idAffectation, notification.title, notification.body);
    } else if (extra.idDemande) {
      notif = NotificationMission.hydrate(notification, extra);
    } else {
      this.#log.warn('Notification par défaut', notification);
      notif = new NotificationBasique(notification.title, notification.body);
    }

    return notif;
  }

  private getExtra(notification: PushNotificationSchema): any {
    if ('extra' in notification) {
      return notification.extra;
    } else if ('data' in notification) {
      return notification.data;
    }
    return undefined;
  }
}
